const mEditionAcademyInvitationsDropDownFilters = {
  mEditionAcademyInvitationsDropDownFilters: {
    buttons: {
      reload: 'ACTUALIZAR',
      search: 'FILTRAR'
    },

    input: {
      actor: {
        label: 'Rol de Usuario'
      },

      email: {
        label: 'Email',
        placeholder: 'usuario@email.com'
      },

      fecha: {
        desde: {
          placeholder: 'Desde - DD MM, AAAA'
        },

        hasta: {
          placeholder: 'Hasta - DD MM, AAAA'
        },

        label: 'Fecha de Envío'
      }
    }
  }
}

export default mEditionAcademyInvitationsDropDownFilters
